module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home-mobile"
    }
  }, [_c('a', {
    attrs: {
      "name": "s-home",
      "id": "s-home"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "just-a-wrap"
  }, [_c('div', {
    staticClass: "banner",
    attrs: {
      "id": "section-banner"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(false) ? _c('div', {
    staticClass: "nav"
  }, [_c('ul', [_c('li', {
    on: {
      "click": function($event) {
        _vm.gotoSection('s-home')
      }
    }
  }, [_c('a', [_vm._v("首页")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "/explore/2017cusc/news/",
      "target": "_blank"
    }
  }, [_vm._v("大会现场")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.gotoSection('s-guest')
      }
    }
  }, [_c('a', [_vm._v("参会嘉宾")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.gotoSection('s-agenda')
      }
    }
  }, [_c('a', [_vm._v("会议议程")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.gotoSection('s-tickets')
      }
    }
  }, [_c('a', [_vm._v("参会购票")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.gotoSection('s-partners')
      }
    }
  }, [_c('a', [_vm._v("合作机构")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.gotoSection('s-location')
      }
    }
  }, [_c('a', [_vm._v("场地信息")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.gotoSection('s-contact-us')
      }
    }
  }, [_c('a', [_vm._v("联系我们")])])])]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "section guest",
    attrs: {
      "id": "section-guest"
    }
  }, [_c('a', {
    attrs: {
      "id": "s-guest"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "guest-list"
  }, _vm._l((_vm.guestList), function(guest) {
    return _c('li', [_c('div', {
      staticClass: "photo"
    }, [_c('img', {
      attrs: {
        "src": guest.photo,
        "alt": "嘉宾姓名"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "name-wrap"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(guest.name))]), _vm._v(" "), _c('div', {
      staticClass: "company"
    }, [_c('div', {
      staticClass: "position"
    }, [_vm._v("\n                                " + _vm._s(guest.position) + "\n                            ")])])])])
  }))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "agenda-bg-area"
    }
  }, [_c('div', {
    staticClass: "section agenda",
    attrs: {
      "id": "section-agenda"
    }
  }, [_c('a', {
    attrs: {
      "id": "s-agenda"
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.agendaData.type[0]) ? _vm._l((_vm.agendaData.type[0]), function(key, index) {
    return _c('div', {
      class: 'agenda-item-' + index
    }, [_c('div', {
      staticClass: "conf-host",
      class: 'conf-host-' + index
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(key.split("|")[0]))]), _vm._v(" "), (key.split('|')[1]) ? _c('div', {
      staticClass: "summary"
    }, [_vm._v(_vm._s(key.split("|")[1]) + " ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "agenad-list"
    }, [_vm._l((_vm.agendaData.meeting[key]), function(agenda) {
      return [_c('agenda-item', {
        attrs: {
          "data": agenda,
          "index": index
        }
      })]
    })], 2)])
  }) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "section agenda",
    attrs: {
      "id": "section-agenda"
    }
  }, [_vm._m(2), _vm._v(" "), (_vm.agendaData.type[1]) ? _vm._l((_vm.agendaData.type[1]), function(key, index) {
    return _c('div', {
      class: 'agenda-item-' + index
    }, [_c('div', {
      staticClass: "conf-host",
      class: 'conf-host-' + index
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(key.split("|")[0]))]), _vm._v(" "), (key.split('|')[1]) ? _c('div', {
      staticClass: "summary"
    }, [_vm._v(_vm._s(key.split("|")[1]) + " ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "agenad-list"
    }, [_vm._l((_vm.agendaData.meeting[key]), function(agenda) {
      return [_c('agenda-item', {
        attrs: {
          "data": agenda,
          "index": index
        }
      })]
    })], 2)])
  }) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "section tickets"
  }, [_c('p', {
    attrs: {
      "id": "s-tickets"
    }
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('span', {
    staticClass: "no-more-invoice"
  }, [_vm._v("12月20日之后将不再提供本次活动的发票")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "tickets-content"
  }, [_c('a', {
    staticClass: "ticket0",
    attrs: {
      "href": _vm.ticketUrl,
      "target": "_blank"
    }
  }, [_vm._m(5)]), _vm._v(" "), _c('a', {
    staticClass: "ticket1",
    attrs: {
      "href": _vm.ticketUrl,
      "target": "_blank"
    }
  }, [_vm._m(6)]), _vm._v(" "), _c('a', {
    staticClass: "ticket2",
    attrs: {
      "href": _vm.ticketUrl,
      "target": "_blank"
    }
  }, [_vm._m(7)]), _vm._v(" "), _c('a', {
    staticClass: "ticket3",
    attrs: {
      "href": _vm.ticketUrl,
      "target": "_blank"
    }
  }, [_vm._m(8)])])]), _vm._v(" "), (false) ? _c('div', {
    attrs: {
      "id": "old-guest-bg-area"
    }
  }, [_c('div', {
    staticClass: "section old-guests"
  }, [_c('p', {
    attrs: {
      "id": "s-old-guest"
    }
  }), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, _vm._l((_vm.oldGuests), function(item) {
    return _c('div', {
      staticClass: "old-guest-item"
    }, [_c('img', {
      attrs: {
        "src": item.img
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "guest-name"
    }, [_vm._v(" " + _vm._s(item.name) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "guest-title"
    }, [_vm._v(" " + _vm._s(item.title))])])
  }))])]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "faq-bg-area"
    }
  }, [_c('div', {
    staticClass: "section faq"
  }, [_c('p', {
    attrs: {
      "id": "s-faq"
    }
  }), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "faq-item"
  }, [_vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), (_vm.showMoreFaq) ? [_vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23)] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "faq-more-btn",
    on: {
      "click": function($event) {
        _vm.showMoreFaq = !_vm.showMoreFaq
      }
    }
  }, [(!_vm.showMoreFaq) ? _c('span', [_vm._v("查看更多")]) : _c('span', [_vm._v("点击收起")])])], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "section partners"
  }, [_c('a', {
    attrs: {
      "name": "s-partners",
      "id": "s-partners"
    }
  }), _vm._v(" "), _vm._m(24), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('a', {
    attrs: {
      "name": "s-partners"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "up-title"
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }), _vm._v(" "), _c('dl', [_vm._l((_vm.partnerList), function(partner) {
    return [_vm._l((partner), function(val, key) {
      return [_c('dt', [_vm._v(_vm._s(key))]), _vm._v(" "), _c('dd', _vm._l((val), function(pic) {
        return _c('img', {
          attrs: {
            "src": pic.logo + '-fintech.partner'
          }
        })
      }))]
    })]
  })], 2)])]), _vm._v(" "), _vm._m(25), _vm._v(" "), _c('div', {
    staticClass: "section about-us"
  }, [_c('a', {
    attrs: {
      "name": "s-contact-us",
      "id": "s-contact-us"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "25px"
    }
  }), _vm._v(" "), _vm._m(26), _vm._v(" "), _c('div', {
    staticClass: "about-us-wrap"
  }, [_vm._m(27), _vm._v(" "), _vm._m(28), _vm._v(" "), (false) ? _c('div', {
    staticClass: "user-item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("票务合作")]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("王艳")]), _vm._v(" "), _c('div', {
    staticClass: "phone"
  }, [_vm._v("187-0117-2011")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_vm._v("wangyan@xfz.cn")])]) : _vm._e(), _vm._v(" "), _vm._m(29)])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showBottomNav) ? _c('div', {
    staticClass: "bottom-buy-link-float"
  }, [_c('a', {
    staticClass: "bottom-nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": "#s-guest"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "bottom-nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": "#s-agenda"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "bottom-nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": "http://www.xfz.cn/explore/xfz2017/news/",
      "target": "_blank"
    }
  }), _vm._v(" "), (false) ? _c('a', {
    staticClass: "bottom-nav-link",
    attrs: {
      "target": "_blank",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": _vm.ticketUrl
    }
  }) : _vm._e()]) : _vm._e()])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/n-m/m-title-guest2-wap.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/n-m/m-title-agenda.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/n-m/m-title-agenda2.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/n-m/m-title-tickets.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "rogers-area",
    attrs: {
      "href": "https://jinshuju.net/f/Jlf1js",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "rogers"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/n-m/m-rogers.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ticket-info"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                        尊享票\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "price-line"
  }, [_c('span', {
    staticClass: "price"
  }, [_vm._v(" 36666元")]), _vm._v(" "), _c('span', {
    staticClass: "count"
  }, [_vm._v(" 限10位名额")])]), _vm._v(" "), _c('div', {
    staticClass: "intro-line"
  }, [_c('ul', [_c('li', [_vm._v("与国际著名投资大师吉姆·罗杰斯半天闭门沟通会 ")]), _vm._v(" "), _c('li', [_vm._v("SSVIP尊享座位，2天通票 ")]), _vm._v(" "), _c('li', [_vm._v("闭门晚宴入场券，与全球最强创投大脑亲密social ")]), _vm._v(" "), _c('li', [_vm._v("限企业/投资机构创始人、高管报名，需要审核 ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "buy-btn"
  }, [_vm._v("\n                    立即购票\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ticket-item"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                          早鸟参会票\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_vm._v("\n                          99元 \n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                          2天通票，尽享4场论坛，20+主题演讲 "), _c('br'), _vm._v("\n                          4000平米展览互动体验"), _c('br'), _vm._v("\n                          座位先到先得"), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "bottom-area"
  }, [_c('div', {
    staticClass: "seat"
  }, [_vm._v("\n                              有限席位\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "buy-btn"
  }, [_vm._v("\n                                立即购票\n                            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ticket-item"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                          2天峰会通票\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_vm._v("\n                          199元 \n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                          2天通票，尽享4场论坛，20+主题演讲 "), _c('br'), _vm._v("\n                          4000平米展览互动体验"), _c('br'), _vm._v("\n                          座位先到先得"), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "bottom-area"
  }, [_c('div', {
    staticClass: "seat"
  }, [_vm._v("\n                              有限席位\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "buy-btn"
  }, [_vm._v("\n                                立即购票\n                            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ticket-item"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                          CEO 票\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_vm._v("\n                          899元 \n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            2天通票，尽享4场论坛，20+主题演讲"), _c('br'), _vm._v("\n                            \u20284000平米展览互动体验"), _c('br'), _vm._v("\n                            保证前排座位"), _c('br'), _vm._v("\n                            演讲嘉宾可公开 PPT 独家分享"), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "bottom-area"
  }, [_c('div', {
    staticClass: "seat"
  }, [_vm._v("\n                              有限席位仅限CEO参加\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "buy-btn"
  }, [_vm._v("\n                                立即购票\n                            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ticket-item"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                          晚宴入场券\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_vm._v("\n                          9999元 \n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                          闭门晚宴入场券，与全球最强创投大脑亲密 social"), _c('br'), _vm._v("\n                          2天通票，尽享4场论坛，20+主题演讲\u20284000平米展览互动体验"), _c('br'), _vm._v("\n                          保证前排座位"), _c('br'), _vm._v("\n                          演讲嘉宾可公开 PPT 独家分享"), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "bottom-area"
  }, [_c('div', {
    staticClass: "seat"
  }, [_vm._v("\n                              有限席位\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "buy-btn"
  }, [_vm._v("\n                                立即购票\n                            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/n-pc/title-old-guests.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/n-m/m-title-faq.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-q"
  }, [_c('span', [_vm._v("Q:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                                购票什么时候截止?\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-a"
  }, [_c('span', [_vm._v("A:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                                购票截止日期为2017年12月3日。\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-q"
  }, [_c('span', [_vm._v("Q:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                                购票付款成功后，如何获得参会凭证？\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-a"
  }, [_c('span', [_vm._v("A:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                                在您成功付款后，您将收到短信提醒，内容包含参会信息及电子票二维码，活动时凭电子票二维码入场。 "), _c('br'), _vm._v("\n                                活动开始前一周，还会短信发送一次参会信息。如果您关注了小饭桌创业课堂（微信号：xfzkf008），届时也会有相应的提醒。\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-q"
  }, [_c('span', [_vm._v("Q:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                                是否可以申请发票？\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-a"
  }, [_c('span', [_vm._v("A:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                                当您的购票订单付款成功后，会有相应的申请发票入口。也可 "), _c('a', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "href": "http://www.xfz.cn/order/",
      "target": "_blank"
    }
  }, [_vm._v("点此申请发票")]), _vm._v("，在相应的订单下方点击申请发票即可。\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-a"
  }, [_c('div', {
    staticClass: "sa-title"
  }, [_vm._v("温馨提示：")]), _vm._v(" "), _c('div', {
    staticClass: "sa-content"
  }, [_vm._v("\n                                1) 大会门票仅开具增值税发票，不提供增值税专用发票；"), _c('br'), _vm._v("\n                                2) 开票内容为：会议服务费 "), _c('br'), _vm._v("\n                                3) 因本公司每月增值税普通发票数量有限，将以申请开票的先后顺序开具并安排快递，不保证当月开票，请谅解。"), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-q"
  }, [_c('span', [_vm._v("Q:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                                观众座位是否有预留？会议现场是否需要对号入座，会议中途离开，座位是否保留？\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-a"
  }, [_c('span', [_vm._v("A:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                                请您核对票务权益，早鸟票、峰会通票用户根据进场顺序安排，不确保坐席，如您中途离开会场，不确保保留座位。\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-q"
  }, [_c('span', [_vm._v("Q:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                                大会现场有同声传译服务吗？如何领取同传设备？\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-a"
  }, [_c('span', [_vm._v("A:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                                有，活动当天请凭借本人身份证，到指定地点换区同传设备，活动结束后，请及时归还同传设备并取回身份证。\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-q"
  }, [_c('span', [_vm._v("Q:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                                大会场馆附近有就餐的地方吗？\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-a"
  }, [_c('span', [_vm._v("A:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                                酒店6层设有自助餐厅；距会场2-7分钟，步行即可到达诸多卖场，中餐、西餐、港式餐厅灯，价位不等，有多样选择。\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/n-m/m-title-partners.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section location"
  }, [_c('a', {
    attrs: {
      "name": "s-location",
      "id": "s-location"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "s-title"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/n-m/m-title-address.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "location-wrap"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/n-m/m-title-contact-us.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("赞助合作")]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("杨福群")]), _vm._v(" "), _c('div', {
    staticClass: "phone"
  }, [_vm._v("158-0116-1560")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_vm._v("fuqun@xfz.cn")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("媒体合作")]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("徐洋")]), _vm._v(" "), _c('div', {
    staticClass: "phone"
  }, [_vm._v("188-1053-9975")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_vm._v("xuyang@xfz.cn")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qrcode"
  }, [_c('img', {
    attrs: {
      "src": "http://static-image.xfz.cn/explore/images/qrcode.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "qrcode-info"
  }, [_c('span', [_vm._v("扫描二维码"), _c('br'), _vm._v("\n                        关注小饭桌公众号")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-99261138"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HomeMobile.vue
// module id = 57
// module chunks = 0